import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').PersonaDataModel>} */

var PERSONA_DATA_TYPE = {
  data: {
    url: '/backend/personas',
    deleteItemUrl: '/backend/personas/{id}',
    dataKey: 'personas',
    idKeyProp: 'Id'
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: "persona",
        text: data.Name,
        app: "Journeys",
        value: "/EOS/engage/#engage/Personas/".concat(id)
      });
    }
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    }
  }, {
    id: 'Journey',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return data.Journey ? React.createElement(Formatter.Link, {
        icon: data.Journey.Type,
        text: data.Journey.Name,
        value: "/EOS/Engage/#engage/Journeys/".concat(data.Id)
      }) : '-';
    }
  }, {
    id: 'SegmentSize',
    icon: 'contacts',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.Text, {
        value: data.SegmentSize
      });
    },
    numeric: true,
    width: 120
  }],
  placeholders: {
    type: 'persona',
    label: function label(data) {
      return data.Name;
    },
    icon: 'persona'
  },
  thumbnail: {
    text: function text(data) {
      return data.Name;
    },
    icon: function icon() {
      return 'persona';
    }
  },
  contextMenu: [{
    label: 'Open'
  }, 'separator', {
    type: 'delete'
  }]
};
export default PERSONA_DATA_TYPE;